/* Isometric brick renderer — draws LEGO-like models on a canvas, no images needed. */
(function () {
  const C = {
    red: '#d6282a', dkred: '#7a1414', blue: '#1f5fbf', dkblue: '#12305e', azure: '#3fb2d1',
    yellow: '#f3c623', orange: '#f2871b', green: '#2f8a3e', dkgreen: '#1f5a2c', lime: '#a9d32a',
    white: '#f2f2f0', lgrey: '#a9adb1', dgrey: '#5e6166', black: '#23262b', tan: '#e2cb93',
    brown: '#6b3c1c', dkbrown: '#3f2412', pink: '#e792b8', purple: '#6d2a9c', gold: '#c99a2e',
    sand: '#9fb9a6', glass: '#1b2a4a', silver: '#c9ccd1', cream: '#f0e6c8', teal: '#1e7f8a'
  };
  const COS = 0.8660254, SIN = 0.5, PLATE = 0.4;

  function hex2rgb(h) { const n = parseInt(h.slice(1), 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
  function shade(h, k) {
    const [r, g, b] = hex2rgb(h);
    const f = v => Math.round(k > 0 ? v + (255 - v) * k : v * (1 + k));
    return `rgb(${f(r)},${f(g)},${f(b)})`;
  }
  // box: {x,y,z,w,d,h,c,studs} — z,h in plates; x,y,w,d in studs
  function B(x, y, z, w, d, h, c, o) { return Object.assign({ x, y, z, w, d, h, c, studs: true }, o || {}); }
  const N = { studs: false };

  /* ---------- models ---------- */
  const M = {};
  M.car = (p) => { p = p || {}; const body = p.body || 'red', glass = p.glass || 'glass';
    const b = [];
    [[1, 0], [1, 5], [8, 0], [8, 5]].forEach(([x, y]) => b.push(B(x, y, 0, 2.2, 1, 4.5, 'black', N)));
    b.push(B(1.5, 6, 1.2, 1.2, 0.08, 2.1, 'silver', N)); b.push(B(8.5, 6, 1.2, 1.2, 0.08, 2.1, 'silver', N));
    b.push(B(0, 1, 1.5, 12, 4, 1.5, 'dgrey', N));
    b.push(B(0, 0, 3, 1, 6, 2, body, N)); b.push(B(1, 1, 3, 2.2, 4, 2, body, N)); b.push(B(3.2, 0, 3, 4.8, 6, 2, body, N)); b.push(B(8, 1, 3, 2.2, 4, 2, body, N)); b.push(B(10.2, 0, 3, 1.8, 6, 2, body, N));
    b.push(B(0.6, 0, 5, 10, 6, 2, body, N));
    b.push(B(10.6, 0.4, 5, 1.4, 5.2, 1, body, N));
    b.push(B(4, 1, 7, 4.5, 4, 2.5, glass, N));
    b.push(B(4.8, 1.2, 9.5, 3, 3.6, 1, body));
    b.push(B(0.4, 1, 7, 0.6, 0.6, 2.2, 'black', N)); b.push(B(0.4, 4.4, 7, 0.6, 0.6, 2.2, 'black', N));
    b.push(B(-0.4, -0.2, 9.2, 2.2, 6.4, 0.7, body, N));
    b.push(B(12, 0.6, 3.6, 0.2, 1.3, 1, 'white', N)); b.push(B(12, 4.1, 3.6, 0.2, 1.3, 1, 'white', N));
    b.push(B(11.2, 0.2, 4.4, 0.8, 0.25, 0.6, 'yellow', N)); b.push(B(11.2, 5.55, 4.4, 0.8, 0.25, 0.6, 'yellow', N));
    b.push(B(4.4, 6, 5.3, 2.2, 0.08, 1.3, 'black', N));
    b.push(B(12, 0.3, 3, 0.25, 5.4, 0.6, 'black', N));
    return b; };
  M.rocket = (p) => { p = p || {}; const a = p.accent || 'orange', w = p.body || 'white'; const b = [];
    b.push(B(0, 0, 0, 4, 4, 3, 'dgrey', N));
    b.push(B(0, 0, 3, 4, 4, 6, w, N)); b.push(B(0, 0, 9, 4, 4, 1, a, N)); b.push(B(0, 0, 10, 4, 4, 6, w, N));
    b.push(B(0.5, 0.5, 16, 3, 3, 2, w, N)); b.push(B(1, 1, 18, 2, 2, 2, a, N)); b.push(B(1.5, 1.5, 20, 1, 1, 2, a, N));
    b.push(B(4, 1, 0, 1.2, 2, 6, a, N)); b.push(B(1, 4, 0, 2, 1.2, 6, a, N)); b.push(B(-1.2, 1, 0, 1.2, 2, 6, a, N)); b.push(B(1, -1.2, 0, 2, 1.2, 6, a, N));
    b.push(B(4, 1.5, 12, 0.2, 1, 1, 'glass', N)); b.push(B(1.5, 4, 12, 1, 0.2, 1, 'glass', N));
    b.push(B(1, 1, -1.5, 2, 2, 1.5, 'lgrey', N));
    return b; };
  M.tower = (p) => { p = p || {}; const wall = p.wall || 'tan', roof = p.roof || 'dkred'; const b = [];
    b.push(B(-0.5, -0.5, 0, 7, 7, 1, 'dgrey', N));
    b.push(B(0, 0, 1, 6, 6, 9, wall, N));
    [[1, 3], [3.5, 3], [1, 6.5], [3.5, 6.5]].forEach(([y, z]) => { b.push(B(6, y, z, 0.15, 1.2, 2, 'glass', N)); b.push(B(y, 6, z, 1.2, 0.15, 2, 'glass', N)); });
    b.push(B(6, 2.4, 1, 0.15, 1.3, 2.6, 'dkbrown', N));
    b.push(B(-0.3, -0.3, 10, 6.6, 6.6, 0.6, 'dgrey', N));
    b.push(B(1, 1, 10.6, 4, 4, 6, wall, N));
    [[1.8, 12.5], [3.2, 12.5]].forEach(([y, z]) => { b.push(B(5, y, z, 0.15, 1, 2, 'glass', N)); b.push(B(y, 5, z, 1, 0.15, 2, 'glass', N)); });
    b.push(B(0.7, 0.7, 16.6, 4.6, 4.6, 0.6, 'dgrey', N));
    b.push(B(1.2, 1.2, 17.2, 3.6, 3.6, 1.2, roof, N)); b.push(B(1.8, 1.8, 18.4, 2.4, 2.4, 1.2, roof, N)); b.push(B(2.4, 2.4, 19.6, 1.2, 1.2, 1.2, roof, N));
    b.push(B(2.75, 2.75, 20.8, 0.5, 0.5, 3, 'gold', N));
    b.push(B(-2, 1, 0, 1.5, 1.5, 3, 'dkgreen', N)); b.push(B(-2.2, 0.8, 3, 1.9, 1.9, 2, 'green', N)); b.push(B(-1.8, 1.2, 5, 1.1, 1.1, 1.5, 'green', N));
    return b; };
  M.train = (p) => { p = p || {}; const body = p.body || 'dkgreen'; const b = [];
    [[1, 0], [4, 0], [7, 0], [1, 3], [4, 3], [7, 3]].forEach(([x, y]) => b.push(B(x, y, 0, 2, 1, 2, 'black', N)));
    b.push(B(0, 1, 0.5, 10.5, 2, 1.5, 'dgrey', N));
    b.push(B(0, 0, 2, 3, 4, 7, body, N)); b.push(B(-0.2, -0.2, 9, 3.4, 4.4, 0.8, 'black', N));
    b.push(B(3, 0.3, 2.6, 7, 3.4, 3.4, body, N)); b.push(B(3, 0, 2, 7, 4, 0.6, 'red', N));
    b.push(B(8.2, 1.4, 6, 1.2, 1.2, 3.2, 'black', N)); b.push(B(8, 1.2, 9.2, 1.6, 1.6, 0.6, 'black', N));
    b.push(B(5.5, 1.4, 6, 1.2, 1.2, 1.2, 'gold', N));
    b.push(B(10, 1.3, 3.6, 0.5, 1.4, 1.4, 'yellow', N));
    b.push(B(10, 0.3, 0.2, 1.4, 3.4, 1.8, 'red', N));
    b.push(B(3, 0.7, 6.3, 0.15, 1, 2, 'glass', N)); b.push(B(3, 2.3, 6.3, 0.15, 1, 2, 'glass', N));
    b.push(B(0.5, 4, 5, 0.9, 0.15, 3, 'glass', N)); b.push(B(1.7, 4, 5, 0.9, 0.15, 3, 'glass', N));
    return b; };
  M.flower = (p) => { p = p || {}; const pet = p.petal || 'red', pet2 = p.petal2 || 'dkred'; const b = [];
    b.push(B(-1, -1, 0, 3, 3, 3, 'brown', N)); b.push(B(-1.2, -1.2, 3, 3.4, 3.4, 0.8, 'brown', N));
    b.push(B(0, 0, 3.8, 1, 1, 9, 'green', N));
    b.push(B(1, 0.1, 6, 2, 0.8, 0.5, 'green', N)); b.push(B(0.1, 1, 8.5, 0.8, 2, 0.5, 'green', N));
    [[-1, -1], [1, 1], [-1, 1], [1, -1]].forEach(([x, y]) => b.push(B(x, y, 11, 1, 1, 2, pet2, N)));
    [[-1, 0], [1, 0], [0, -1], [0, 1]].forEach(([x, y]) => b.push(B(x, y, 12, 1, 1, 2.2, pet, N)));
    b.push(B(0, 0, 12.8, 1, 1, 1.6, 'yellow'));
    return b; };
  M.ship = (p) => { p = p || {}; const sail = p.sail || 'cream', stripe = p.stripe || 'red'; const b = [];
    b.push(B(0, 0, 0, 12, 4, 3, 'brown', N)); b.push(B(12, 0.8, 0.5, 2, 2.4, 2.5, 'brown', N)); b.push(B(14, 1.4, 1.5, 1.2, 1.2, 1.5, 'brown', N));
    b.push(B(0, 0, 3, 12, 4, 0.6, 'tan', N));
    b.push(B(0, 0, 3.6, 3, 4, 3, 'dkbrown', N)); b.push(B(-0.3, -0.3, 6.6, 3.6, 4.6, 0.6, 'tan', N));
    b.push(B(0.3, 4, 1, 11.4, 0.1, 0.8, 'gold', N));
    b.push(B(4, 1.5, 3.6, 1, 1, 24, 'dkbrown', N)); b.push(B(8.5, 1.5, 3.6, 1, 1, 20, 'dkbrown', N));
    b.push(B(4.5, -1.8, 7, 0.18, 6.6, 7, sail, N)); b.push(B(4.5, -1.4, 15, 0.18, 5.8, 7, sail, N));
    b.push(B(9, -1.4, 6.5, 0.18, 5.8, 6, sail, N)); b.push(B(9, -1, 13.5, 0.18, 5, 6, sail, N));
    b.push(B(4.68, -1.6, 10.5, 0.05, 6.2, 0.7, stripe, N)); b.push(B(4.68, -1.2, 18.5, 0.05, 5.4, 0.7, stripe, N));
    b.push(B(9.18, -1.2, 9.5, 0.05, 5.4, 0.7, stripe, N)); b.push(B(9.18, -0.8, 16.5, 0.05, 4.6, 0.7, stripe, N));
    b.push(B(4.1, 1.6, 27.6, 1.8, 0.1, 1, stripe, N));
    return b; };
  M.robot = (p) => { p = p || {}; const body = p.body || 'lime'; const b = [];
    b.push(B(-0.5, -0.5, 0, 2.5, 2, 1, 'dgrey', N)); b.push(B(-0.5, 3.5, 0, 2.5, 2, 1, 'dgrey', N));
    b.push(B(0, 0, 1, 2, 2, 5, 'lgrey', N)); b.push(B(0, 3, 1, 2, 2, 5, 'lgrey', N));
    b.push(B(0, 0, 6, 2, 5, 2, 'dgrey', N));
    b.push(B(-0.5, -0.2, 8, 3, 5.4, 6, body, N));
    b.push(B(2.5, 1, 10, 0.2, 3, 2, 'black', N)); b.push(B(2.7, 1.5, 10.5, 0.1, 0.6, 0.6, 'azure', N));
    b.push(B(-0.5, -1.8, 12, 3, 1.6, 2.5, 'dgrey', N)); b.push(B(-0.5, 5.2, 12, 3, 1.6, 2.5, 'dgrey', N));
    b.push(B(0, -1.6, 6.5, 2, 1.2, 5.5, 'lgrey', N)); b.push(B(0, 5.4, 6.5, 2, 1.2, 5.5, 'lgrey', N));
    b.push(B(0.3, -1.4, 5.2, 1.6, 1, 1.3, 'dgrey', N)); b.push(B(0.3, 5.6, 5.2, 1.6, 1, 1.3, 'dgrey', N));
    b.push(B(0, 1, 14, 2.2, 3, 3.4, 'lgrey', N)); b.push(B(2.2, 1.3, 15.2, 0.15, 2.4, 1.2, 'azure', N));
    b.push(B(0.5, 1.5, 17.4, 1.2, 2, 0.8, body));
    return b; };
  M.castle = (p) => { const b = [];
    b.push(B(-0.5, -0.5, 0, 5, 8, 1, 'dgrey', N));
    b.push(B(0, 0, 1, 4, 4, 12, 'lgrey', N));
    [[0, 0], [3, 0], [0, 3], [3, 3]].forEach(([x, y]) => b.push(B(x, y, 13, 1, 1, 1.5, 'lgrey', N)));
    b.push(B(4, 1.2, 1, 0.2, 1.6, 3.6, 'black', N)); b.push(B(4, 1.5, 7, 0.2, 1, 2, 'black', N)); b.push(B(1.5, 4, 9, 1, 0.2, 2, 'black', N));
    b.push(B(0.5, 0.5, 14.5, 3, 3, 1.2, 'dkblue', N)); b.push(B(1, 1, 15.7, 2, 2, 1.2, 'dkblue', N)); b.push(B(1.5, 1.5, 16.9, 1, 1, 1.4, 'dkblue', N));
    b.push(B(1.9, 1.9, 18.3, 0.2, 0.2, 2, 'dgrey', N)); b.push(B(2.1, 1.95, 19.5, 1, 0.1, 0.7, 'red', N));
    b.push(B(0, 4, 1, 4, 3, 6, 'lgrey', N));
    [[0, 6], [3, 6]].forEach(([x, y]) => b.push(B(x, y, 7, 1, 1, 1.2, 'lgrey', N))); b.push(B(1.5, 6, 7, 1, 1, 1.2, 'lgrey', N));
    b.push(B(4, 5, 2, 0.2, 1, 2, 'black', N));
    return b; };
  M.tractor = (p) => { p = p || {}; const body = p.body || 'green', rim = p.rim || 'yellow'; const b = [];
    b.push(B(0, -0.2, 0, 3.2, 1.2, 5.5, 'black', N)); b.push(B(0, 4, 0, 3.2, 1.2, 5.5, 'black', N));
    b.push(B(6, 0.2, 0, 2, 1, 3.2, 'black', N)); b.push(B(6, 3.8, 0, 2, 1, 3.2, 'black', N));
    b.push(B(0.9, 5.2, 1.6, 1.4, 0.12, 2.2, rim, N)); b.push(B(6.5, 4.8, 0.9, 1, 0.12, 1.4, rim, N));
    b.push(B(0, 1, 2, 8.5, 3, 3, body, N));
    b.push(B(4, 1, 5, 4.5, 3, 2.2, body, N)); b.push(B(8.5, 1.2, 3, 0.4, 2.6, 4, 'dgrey', N));
    b.push(B(0, 1, 5, 3, 3, 5.5, body, N)); b.push(B(-0.2, 0.8, 10.5, 3.4, 3.4, 0.6, 'black', N));
    b.push(B(3, 1.3, 6.5, 0.15, 2.4, 3.5, 'glass', N)); b.push(B(0.4, 4, 6.5, 2.2, 0.15, 3.5, 'glass', N));
    b.push(B(6.8, 1.3, 7.2, 0.6, 0.6, 3.5, 'dgrey', N));
    b.push(B(8.9, 1.5, 4, 0.3, 0.7, 0.7, 'white', N)); b.push(B(8.9, 2.8, 4, 0.3, 0.7, 0.7, 'white', N));
    return b; };
  M.engine = (p) => { p = p || {}; const head = p.head || 'red'; const b = [];
    b.push(B(0, 0, 0, 6, 4, 5, 'dgrey', N));
    b.push(B(-0.2, -0.6, 5, 6.4, 1.6, 3, head, N)); b.push(B(-0.2, 3, 5, 6.4, 1.6, 3, head, N));
    b.push(B(0.5, 1, 5, 5, 2, 2, 'lgrey', N));
    [0.8, 2.1, 3.4, 4.7].forEach(x => { b.push(B(x, 1.3, 7, 0.7, 0.6, 1.2, 'silver', N)); b.push(B(x, 2.1, 7, 0.7, 0.6, 1.2, 'silver', N)); });
    b.push(B(1.5, 1, 8.2, 3, 2, 1.2, 'black', N)); b.push(B(1.2, 0.7, 9.4, 3.6, 2.6, 1.2, 'black', N));
    b.push(B(6, 1.5, 1.2, 0.6, 1, 1.6, 'silver', N)); b.push(B(6, 0.3, 2.2, 0.3, 0.6, 2.4, 'black', N)); b.push(B(6, 3.1, 2.2, 0.3, 0.6, 2.4, 'black', N));
    [0.6, 2, 3.4, 4.8].forEach(x => b.push(B(x, 4.6, 5.4, 0.6, 0.8, 0.6, 'silver', N)));
    b.push(B(0, 4.6, 0.6, 6, 0.5, 0.5, 'silver', N));
    b.push(B(-1, 0.5, -0.4, 8, 3, 0.4, 'black', N));
    return b; };
  M.heli = (p) => { p = p || {}; const body = p.body || 'red'; const b = [];
    b.push(B(1, -0.6, 0, 7, 0.5, 0.8, 'black', N)); b.push(B(1, 3.1, 0, 7, 0.5, 0.8, 'black', N));
    b.push(B(2, -0.1, 0.8, 0.5, 3.2, 1.2, 'black', N)); b.push(B(6, -0.1, 0.8, 0.5, 3.2, 1.2, 'black', N));
    b.push(B(0, 0, 2, 8, 3, 4, body, N)); b.push(B(8, 0.3, 2, 2, 2.4, 3.2, 'glass', N));
    b.push(B(0, 3, 4.2, 8, 0.05, 0.6, 'white', N));
    b.push(B(-6, 1, 4, 6, 1, 1, body, N)); b.push(B(-6.4, 1.2, 5, 1.2, 0.6, 3, body, N));
    b.push(B(-6.2, 1.8, 6, 0.3, 0.12, 2.4, 'dgrey', N));
    b.push(B(3.5, 1, 6, 1, 1, 1.6, 'dgrey', N));
    b.push(B(-4, 1.3, 7.6, 7.3, 0.4, 0.3, 'dgrey', N)); b.push(B(4.5, 1.3, 7.6, 6.3, 0.4, 0.3, 'dgrey', N));
    b.push(B(3.8, -3.5, 7.6, 0.4, 4.6, 0.3, 'dgrey', N)); b.push(B(3.8, 1.9, 7.6, 0.4, 4.6, 0.3, 'dgrey', N));
    b.push(B(3.6, 1.1, 7.6, 0.8, 0.8, 0.5, 'black', N));
    b.push(B(2, 3, 2.8, 2, 0.15, 1.3, 'glass', N)); b.push(B(5, 3, 2.8, 1, 0.15, 1.3, 'glass', N));
    return b; };
  M.moto = (p) => { p = p || {}; const tank = p.tank || 'red'; const b = [];
    b.push(B(0, 1.2, 0, 2, 0.8, 6, 'black', N)); b.push(B(7.5, 1.2, 0, 2, 0.8, 6, 'black', N));
    b.push(B(0.6, 2, 2, 0.8, 0.08, 2, 'silver', N)); b.push(B(8.1, 2, 2, 0.8, 0.08, 2, 'silver', N));
    b.push(B(2, 1.3, 3, 5.5, 0.6, 1.2, 'dgrey', N));
    b.push(B(2.6, 0.8, 2, 2.2, 1.6, 2.2, 'silver', N)); b.push(B(2.6, 0.5, 1.2, 2.2, 0.4, 1, 'black', N));
    b.push(B(4.2, 0.9, 4.2, 2.6, 1.4, 2, tank, N));
    b.push(B(2, 1, 4.2, 2.2, 1.2, 1, 'black', N)); b.push(B(1.4, 1.1, 4.4, 0.6, 1, 0.6, 'red', N));
    b.push(B(6.8, 1.35, 2.5, 0.5, 0.5, 4, 'silver', N));
    b.push(B(7, 0, 6.5, 0.4, 3.2, 0.4, 'dgrey', N));
    b.push(B(7.4, 1.2, 4.6, 0.6, 0.8, 0.9, 'white', N));
    b.push(B(4.8, 2.4, 1.4, 3.4, 0.4, 0.4, 'silver', N));
    return b; };
  M.dino = (p) => { p = p || {}; const skin = p.skin || 'tan'; const b = [];
    b.push(B(3, 0, 0, 2, 1.4, 5, skin, N)); b.push(B(3, 3.6, 0, 2, 1.4, 5, skin, N));
    b.push(B(2.6, -0.4, 0, 2.8, 1.2, 0.8, skin, N)); b.push(B(2.6, 4.2, 0, 2.8, 1.2, 0.8, skin, N));
    b.push(B(0, 0.5, 5, 8, 4, 4, skin, N));
    b.push(B(-5, 1.5, 6, 5, 2, 2, skin, N)); b.push(B(-8.5, 2, 6.6, 3.5, 1, 1, skin, N));
    b.push(B(7, 1.5, 8, 2, 2, 3, skin, N));
    b.push(B(8, 1, 11, 5, 3, 2.6, skin, N)); b.push(B(8.6, 1.1, 9.8, 4.4, 2.8, 1.2, skin, N));
    b.push(B(13, 1.4, 12, 0.12, 0.7, 0.7, 'black', N)); b.push(B(13, 1.2, 10.9, 0.1, 2.6, 0.3, 'white', N));
    b.push(B(8, 0.3, 7, 1.6, 0.7, 0.7, skin, N)); b.push(B(8, 4, 7, 1.6, 0.7, 0.7, skin, N));
    [1, 3, 5].forEach(x => b.push(B(x, 2, 9, 1, 1, 0.8, skin, N)));
    return b; };
  M.van = (p) => { p = p || {}; const body = p.body || 'white', stripe = p.stripe || 'orange'; const b = [];
    [[1, 0], [6, 0], [1, 4.2], [6, 4.2]].forEach(([x, y]) => b.push(B(x, y, 0, 2, 0.8, 2.6, 'black', N)));
    b.push(B(0, 0.5, 1, 9, 4, 3, body, N)); b.push(B(0, 0.5, 4, 9, 4, 1, stripe, N)); b.push(B(0, 0.5, 5, 9, 4, 4, body, N));
    b.push(B(9, 1, 5.4, 0.15, 3, 3, 'glass', N)); b.push(B(1, 4.5, 5.6, 2.2, 0.15, 2.4, 'glass', N)); b.push(B(4, 4.5, 5.6, 2.2, 0.15, 2.4, 'glass', N)); b.push(B(6.8, 4.5, 5.6, 1.4, 0.15, 2.4, 'glass', N));
    b.push(B(0.6, 1, 9, 6, 3, 0.5, 'black', N));
    b.push(B(9, 0.8, 1.8, 0.2, 0.9, 0.9, 'white', N)); b.push(B(9, 3.3, 1.8, 0.2, 0.9, 0.9, 'white', N));
    b.push(B(9, 0.5, 1, 0.3, 4, 0.6, 'dgrey', N));
    return b; };
  M.buggy = (p) => { p = p || {}; const body = p.body || 'orange'; const b = [];
    [[0, -0.6], [0, 4.4], [7, -0.6], [7, 4.4]].forEach(([x, y]) => b.push(B(x, y, 0, 3, 1.3, 6, 'black', N)));
    b.push(B(0.9, 5.7, 1.8, 1.2, 0.12, 2.4, 'lgrey', N)); b.push(B(7.9, 5.7, 1.8, 1.2, 0.12, 2.4, 'lgrey', N));
    b.push(B(0, 0.7, 2, 10, 3.7, 2, body, N));
    [[3, 0.9], [3, 3.9], [7, 0.9], [7, 3.9]].forEach(([x, y]) => b.push(B(x, y, 4, 0.5, 0.5, 5.5, 'dgrey', N)));
    b.push(B(3, 0.9, 9.5, 4.5, 0.5, 0.5, 'dgrey', N)); b.push(B(3, 3.9, 9.5, 4.5, 0.5, 0.5, 'dgrey', N));
    b.push(B(3, 1.4, 9.5, 0.5, 2.5, 0.5, 'dgrey', N)); b.push(B(7, 1.4, 9.5, 0.5, 2.5, 0.5, 'dgrey', N));
    b.push(B(4, 1.2, 4, 2, 1.3, 2.5, 'black', N)); b.push(B(4, 2.9, 4, 2, 1.3, 2.5, 'black', N));
    b.push(B(7.5, 0.7, 4, 2.5, 3.7, 1.4, body, N));
    b.push(B(10, 1.2, 4.4, 0.3, 0.8, 0.8, 'white', N)); b.push(B(10, 3.2, 4.4, 0.3, 0.8, 0.8, 'white', N));
    b.push(B(7.5, 1.9, 9.9, 1.4, 1.4, 0.6, 'white', N));
    b.push(B(-0.5, 0.9, 3, 0.5, 3.3, 0.8, 'dgrey', N));
    return b; };
  M.bricks = (p) => { p = p || {}; const seed = p.seed || 1; const b = [];
    let s = seed; const rnd = () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
    const cols = p.colors || ['red', 'blue', 'yellow', 'white', 'green', 'orange', 'black', 'lgrey', 'azure', 'lime'];
    const sizes = [[2, 4], [4, 2], [2, 2], [1, 4], [4, 1], [2, 3], [1, 2], [2, 1]];
    const n = p.n || 14, span = p.span || 14;
    const placed = [];
    for (let i = 0; i < n; i++) {
      const [w, d] = sizes[Math.floor(rnd() * sizes.length)];
      const x = Math.round(rnd() * span), y = Math.round(rnd() * span);
      const h = rnd() < 0.3 ? 1 : 3;
      let z = 0;
      placed.forEach(q => { if (x < q.x + q.w && x + w > q.x && y < q.y + q.d && y + d > q.y) z = Math.max(z, q.z + q.h); });
      if (z > 9) continue;
      const box = B(x, y, z, w, d, h, cols[Math.floor(rnd() * cols.length)]);
      placed.push(box); b.push(box);
    }
    return b; };
  M.box = (p) => { p = p || {}; const b = [];
    b.push(B(0, 0, 0, 10, 7, 7, p.color || 'black', N));
    b.push(B(10, 0, 0, 0.05, 7, 0.9, 'white', N));
    return b; };
  M.boxes = (p) => { const b = [];
    b.push(B(0, 0, 0, 10, 7, 6, 'black', N)); b.push(B(0.5, 0.5, 6, 9, 6, 5, 'black', N)); b.push(B(1, 1, 11, 8, 5, 5, 'black', N));
    b.push(B(10, 0, 0, 0.05, 7, 1.2, 'white', N)); b.push(B(9.5, 0.5, 6, 0.05, 6, 1.2, 'white', N)); b.push(B(9, 1, 11, 0.05, 5, 1.2, 'white', N));
    return b; };
  M.plane = (p) => { p = p || {}; const body = p.body || 'lgrey'; const b = [];
    b.push(B(0, 1.5, 2, 12, 2, 2.4, body, N)); b.push(B(12, 1.8, 2.3, 2.5, 1.4, 1.6, body, N)); b.push(B(14.5, 2.1, 2.6, 1.2, 0.8, 0.9, 'dgrey', N));
    b.push(B(8.5, 1.7, 4.4, 2.6, 1.6, 1.2, 'glass', N));
    b.push(B(4, -4, 2.4, 3.5, 5.5, 0.5, body, N)); b.push(B(4, 3.5, 2.4, 3.5, 5.5, 0.5, body, N));
    b.push(B(0, -1, 2.6, 2, 2.5, 0.4, body, N)); b.push(B(0, 3.5, 2.6, 2, 2.5, 0.4, body, N));
    b.push(B(0, 2.2, 4.4, 2.4, 0.6, 3.2, body, N));
    b.push(B(4.5, -3.5, 1.4, 1.2, 0.6, 1, 'dgrey', N)); b.push(B(4.5, 7.9, 1.4, 1.2, 0.6, 1, 'dgrey', N));
    b.push(B(5, -3.8, 1.9, 2.4, 1.2, 0.5, 'red', N)); b.push(B(5, 7.6, 1.9, 2.4, 1.2, 0.5, 'red', N));
    b.push(B(4, 2.1, 0, 0.5, 0.8, 2, 'dgrey', N)); b.push(B(11, 2.1, 0, 0.5, 0.8, 2, 'dgrey', N));
    return b; };
  M.truck = (p) => { p = p || {}; const cab = p.cab || 'yellow'; const b = [];
    [[1, 0], [1, 4.2], [7, 0], [7, 4.2], [9.5, 0], [9.5, 4.2]].forEach(([x, y]) => b.push(B(x, y, 0, 2, 0.8, 3, 'black', N)));
    b.push(B(0, 0.6, 1, 13, 3.8, 1.6, 'dgrey', N));
    b.push(B(9.5, 0.5, 2.6, 3.5, 4, 6, cab, N)); b.push(B(13, 1, 5.2, 0.15, 3, 2.8, 'glass', N)); b.push(B(10.5, 4.5, 5.2, 1.8, 0.15, 2.4, 'glass', N));
    b.push(B(13, 0.8, 3, 0.25, 0.9, 0.9, 'white', N)); b.push(B(13, 3.3, 3, 0.25, 0.9, 0.9, 'white', N));
    b.push(B(13, 0.5, 2.2, 0.4, 4, 0.7, 'dgrey', N));
    b.push(B(0, 0.4, 2.6, 9, 4.2, 1, 'dgrey', N));
    b.push(B(0, 0.4, 3.6, 9, 0.3, 3, cab, N)); b.push(B(0, 4.3, 3.6, 9, 0.3, 3, cab, N)); b.push(B(0, 0.7, 3.6, 0.3, 3.6, 3, cab, N));
    b.push(B(1, 1, 3.6, 6, 3, 1.4, 'tan', N)); b.push(B(2, 1.5, 5, 3, 2, 1, 'lgrey', N));
    b.push(B(10, 1.2, 8.6, 2.5, 2.6, 0.4, 'orange', N));
    return b; };
  M.satellite = (p) => { const b = [];
    b.push(B(0, 0, 3, 4, 4, 6, 'gold', N)); b.push(B(-0.3, -0.3, 9, 4.6, 4.6, 0.6, 'lgrey', N));
    b.push(B(4, 1.2, 5, 1, 1.6, 1.6, 'dgrey', N)); b.push(B(5, 0.5, 4.5, 2, 3, 2.6, 'white', N));
    b.push(B(1.5, 4, 5.2, 1, 1, 1.4, 'dgrey', N)); b.push(B(1, 5, 5.4, 2, 9, 0.5, 'dkblue', N)); b.push(B(1, -9, 5.4, 2, 9, 0.5, 'dkblue', N)); b.push(B(1.5, -1, 5.2, 1, 1, 1.4, 'dgrey', N));
    [6, 8, 10, 12].forEach(y => { b.push(B(1, y, 5.9, 2, 0.1, 0.1, 'silver', N)); b.push(B(1, -y, 5.9, 2, 0.1, 0.1, 'silver', N)); });
    b.push(B(1.5, 1.5, 9.6, 1, 1, 2.6, 'lgrey', N)); b.push(B(0.5, 0.5, 12.2, 3, 3, 0.4, 'white', N));
    b.push(B(1.5, 1.5, 0, 1, 1, 3, 'dgrey', N));
    return b; };
  M.minifig = (p) => { p = p || {}; const torso = p.torso || 'blue', legs = p.legs || 'dkblue', hair = p.hair || 'brown'; const b = [];
    b.push(B(0, 0, 0, 2, 1.1, 4.5, legs, N)); b.push(B(0, 1.4, 0, 2, 1.1, 4.5, legs, N));
    b.push(B(0, 0, 4.5, 2, 2.5, 1, legs, N));
    b.push(B(-0.2, -0.2, 5.5, 2.4, 2.9, 5, torso, N));
    b.push(B(-0.1, -1.3, 6.2, 1.6, 1.1, 4.2, torso, N)); b.push(B(-0.1, 2.7, 6.2, 1.6, 1.1, 4.2, torso, N));
    b.push(B(0.1, -1.2, 5, 1.2, 0.9, 1.2, 'yellow', N)); b.push(B(0.1, 2.8, 5, 1.2, 0.9, 1.2, 'yellow', N));
    b.push(B(0.3, 0.3, 10.5, 1.4, 1.9, 0.8, 'yellow', N)); b.push(B(0, 0, 11.3, 2, 2.5, 3.4, 'yellow', N));
    b.push(B(2, 0.5, 13, 0.1, 0.4, 0.4, 'black', N)); b.push(B(2, 1.6, 13, 0.1, 0.4, 0.4, 'black', N)); b.push(B(2, 0.7, 12, 0.1, 1.1, 0.25, 'black', N));
    b.push(B(-0.2, -0.2, 14.7, 2.4, 2.9, 1.2, hair, N)); b.push(B(0.5, 0.5, 15.9, 1, 1.5, 0.3, hair, N));
    return b; };


  M.f1 = (p) => { p = p || {}; const body = p.body || 'red'; const b = [];
    [[0.5, -0.8], [0.5, 4.6], [9.5, -0.6], [9.5, 4.4]].forEach(([x, y], i) => b.push(B(x, y, 0, i < 2 ? 2.4 : 2, i < 2 ? 1.2 : 1.2, i < 2 ? 4 : 3.6, 'black', N)));
    b.push(B(0, 1, 1, 13, 3, 1, body, N)); b.push(B(2, 1.3, 2, 8, 2.4, 2.2, body, N)); b.push(B(10, 1.6, 2, 3.5, 1.8, 1.4, body, N));
    b.push(B(5, 1.6, 4.2, 3, 1.8, 1.4, body, N)); b.push(B(6.2, 1.9, 5.6, 1.2, 1.2, 0.8, 'black', N)); b.push(B(8, 1.5, 4.2, 1, 2, 1.2, 'glass', N));
    b.push(B(4.5, 2.1, 5.6, 1.4, 0.8, 1.6, 'dgrey', N));
    b.push(B(-0.6, -1, 3.4, 1.8, 7, 0.5, body, N)); b.push(B(-0.6, -1, 3.9, 0.5, 7, 0.8, 'black', N));
    b.push(B(12.5, -0.8, 1.2, 1.6, 6.6, 0.4, body, N)); b.push(B(13.9, -0.8, 1, 0.3, 1.2, 1.2, 'black', N)); b.push(B(13.9, 4.6, 1, 0.3, 1.2, 1.2, 'black', N));
    b.push(B(2, 0.2, 2, 3, 0.9, 1.4, 'black', N)); b.push(B(2, 3.9, 2, 3, 0.9, 1.4, 'black', N));
    return b; };
  M.pickup = (p) => { p = p || {}; const body = p.body || 'black'; const b = [];
    [[1, -0.2], [1, 5.2], [8.5, -0.2], [8.5, 5.2]].forEach(([x, y]) => b.push(B(x, y, 0, 2.4, 1, 3.6, 'black', N)));
    b.push(B(1.4, 6.2, 1, 1.4, 0.1, 1.8, 'silver', N)); b.push(B(8.9, 6.2, 1, 1.4, 0.1, 1.8, 'silver', N));
    b.push(B(0, 0.5, 2, 12, 5, 1.2, 'dgrey', N));
    b.push(B(0, 0, 3.2, 6, 6, 2.4, body, N)); b.push(B(0, 0, 5.6, 6, 0.4, 1.4, body, N)); b.push(B(0, 5.6, 5.6, 6, 0.4, 1.4, body, N)); b.push(B(0, 0, 5.6, 0.4, 6, 1.4, body, N));
    b.push(B(6, 0, 3.2, 3.5, 6, 2.4, body, N)); b.push(B(6, 0.4, 5.6, 3.5, 5.2, 3.2, body, N)); b.push(B(9.5, 0.8, 6, 0.15, 4.4, 2.4, 'glass', N)); b.push(B(6.8, 5.6, 6, 2, 0.15, 2.2, 'glass', N));
    b.push(B(9.5, 0, 3.2, 3, 6, 2.4, body, N)); b.push(B(9.5, 0.3, 5.6, 2.8, 5.4, 0.8, body, N));
    b.push(B(12.5, 0.6, 3.6, 0.2, 1, 1, 'white', N)); b.push(B(12.5, 4.4, 3.6, 0.2, 1, 1, 'white', N)); b.push(B(12.5, 1.8, 3.6, 0.3, 2.4, 1.6, 'silver', N));
    b.push(B(12.5, 0.2, 2.6, 0.5, 5.6, 0.7, 'silver', N));
    return b; };
  M.excavator = (p) => { p = p || {}; const body = p.body || 'yellow'; const b = [];
    b.push(B(0, -0.5, 0, 7, 1.4, 2.4, 'black', N)); b.push(B(0, 4.1, 0, 7, 1.4, 2.4, 'black', N)); b.push(B(0.5, 1, 1, 6, 3, 1.2, 'dgrey', N));
    b.push(B(1, 0.5, 2.2, 5, 4, 0.8, 'dgrey', N));
    b.push(B(0, 0.5, 3, 5.5, 4, 3, body, N)); b.push(B(4, 0.8, 6, 1.6, 3.4, 2.8, body, N)); b.push(B(5.6, 1, 6.4, 0.15, 3, 2.2, 'glass', N)); b.push(B(4.4, 4.2, 6.4, 1, 0.15, 2.2, 'glass', N));
    b.push(B(0.3, 1, 6, 2.2, 3, 1.2, 'dgrey', N)); b.push(B(0.6, 1.5, 7.2, 0.8, 0.8, 1.4, 'black', N));
    b.push(B(5.5, 2, 5, 6, 1, 1, body, N)); b.push(B(11, 2.1, 1.5, 1, 0.8, 4.5, body, N)); b.push(B(11.5, 1.3, 0.4, 2.4, 2.4, 1.4, 'dgrey', N)); b.push(B(13.9, 1.1, 0, 0.5, 2.8, 2.2, 'dgrey', N));
    b.push(B(7.5, 2.3, 6, 0.5, 0.4, 1.6, 'silver', N)); b.push(B(9, 2.3, 6, 0.5, 0.4, 1.2, 'silver', N));
    return b; };
  M.skull = (p) => { p = p || {}; const bone = p.bone || 'white', rose = p.rose || 'red'; const b = [];
    b.push(B(-0.5, -0.5, 0, 6, 6, 0.8, 'black', N)); b.push(B(0, 0, 0.8, 5, 5, 0.6, 'black', N));
    b.push(B(0.8, 0.8, 1.4, 3.4, 3.4, 2.6, bone, N)); b.push(B(0.4, 0.4, 4, 4.2, 4.2, 4.5, bone, N)); b.push(B(0.8, 0.8, 8.5, 3.4, 3.4, 1.2, bone, N));
    b.push(B(4.6, 1, 5.5, 0.15, 1, 1.4, 'black', N)); b.push(B(4.6, 3, 5.5, 0.15, 1, 1.4, 'black', N)); b.push(B(4.6, 2.1, 3.6, 0.15, 0.8, 1.2, 'black', N));
    [1, 1.8, 2.6, 3.4].forEach(y => b.push(B(4.6, y, 1.6, 0.15, 0.5, 1.2, 'dgrey', N)));
    b.push(B(2, 2, 9.7, 0.6, 0.6, 5, 'green', N)); b.push(B(1, 1, 14.5, 2.6, 2.6, 1.6, 'dkred', N)); b.push(B(1.5, 1.5, 15.6, 1.6, 1.6, 1.6, rose, N)); b.push(B(2, 2, 16.8, 0.6, 0.6, 1, rose, N));
    b.push(B(3, 2.2, 11.5, 1.6, 0.4, 0.4, 'green', N)); b.push(B(2.2, 0.5, 12.8, 0.4, 1.6, 0.4, 'green', N));
    return b; };
  M.sub = (p) => { p = p || {}; const body = p.body || 'yellow'; const b = [];
    b.push(B(-1, -0.5, 0, 14, 5, 0.6, 'dgrey', N));
    b.push(B(0, 0.5, 1.5, 12, 3, 3, body, N)); b.push(B(12, 1, 2, 1.6, 2, 2, body, N)); b.push(B(13.6, 1.5, 2.4, 0.8, 1, 1.2, 'dgrey', N));
    b.push(B(-0.8, 1.2, 1.8, 0.8, 1.6, 2.4, body, N)); b.push(B(-1.6, 1.7, 2.4, 0.8, 0.6, 1.2, 'dgrey', N)); b.push(B(-1.9, 1.3, 2.1, 0.3, 1.4, 1.8, 'black', N));
    b.push(B(5, 1.2, 4.5, 3, 1.6, 2.6, body, N)); b.push(B(6, 1.6, 7.1, 0.5, 0.5, 2, 'dgrey', N)); b.push(B(7, 1.6, 7.1, 0.5, 0.5, 1.4, 'dgrey', N));
    b.push(B(8.5, 3.5, 2.6, 1, 0.1, 1, 'glass', N)); b.push(B(3, 3.5, 2.6, 1, 0.1, 1, 'glass', N)); b.push(B(12, 1.6, 3.2, 0.1, 0.8, 0.8, 'glass', N));
    b.push(B(4, -0.5, 2.3, 4, 1, 0.5, body, N)); b.push(B(4, 3.5, 2.3, 4, 1, 0.5, body, N));
    return b; };
  M.tank = (p) => { p = p || {}; const body = p.body || 'dkgreen'; const b = [];
    b.push(B(0, -0.5, 0, 11, 1.8, 2.6, 'black', N)); b.push(B(0, 4.7, 0, 11, 1.8, 2.6, 'black', N));
    [1, 3.5, 6, 8.5].forEach(x => { b.push(B(x, 6.5, 0.6, 1.6, 0.05, 1.4, 'dgrey', N)); });
    b.push(B(0.5, 1.3, 1, 10, 3.4, 1.6, body, N)); b.push(B(-0.3, -0.5, 2.6, 11.6, 7, 1.4, body, N));
    b.push(B(2.5, 1, 4, 5, 4, 2.4, body, N)); b.push(B(3, 1.5, 6.4, 1.4, 1.4, 1, 'black', N)); b.push(B(6, 1.5, 6.4, 0.8, 0.8, 0.8, 'dgrey', N));
    b.push(B(7.5, 2.6, 5, 7, 0.8, 0.8, body, N)); b.push(B(13.5, 2.5, 4.9, 1, 1, 1, 'black', N));
    b.push(B(-0.5, 0.5, 4, 0.6, 1, 0.6, 'dgrey', N)); b.push(B(-0.5, 4.5, 4, 0.6, 1, 0.6, 'dgrey', N)); b.push(B(11.3, 0.2, 2.6, 0.3, 0.8, 0.8, 'white', N)); b.push(B(11.3, 5, 2.6, 0.3, 0.8, 0.8, 'white', N));
    return b; };

  /* ---------- renderer ---------- */
  function P(x, y, zp) { return [(x - y) * COS, (x + y) * SIN - zp * PLATE]; }

  function order(boxes) {
    const n = boxes.length, after = Array.from({ length: n }, () => []), indeg = new Array(n).fill(0);
    const eps = 1e-6;
    for (let i = 0; i < n; i++) for (let j = 0; j < n; j++) {
      if (i === j) continue; const a = boxes[i], b = boxes[j];
      const aFront = a.x >= b.x + b.w - eps || a.y >= b.y + b.d - eps || a.z >= b.z + b.h - eps;
      const bFront = b.x >= a.x + a.w - eps || b.y >= a.y + a.d - eps || b.z >= a.z + a.h - eps;
      if (aFront && !bFront) { after[j].push(i); indeg[i]++; }
    }
    const depth = boxes.map(b => b.x + b.w / 2 + b.y + b.d / 2 + (b.z + b.h / 2) * PLATE);
    const out = [], seen = new Array(n).fill(false); let q = [];
    for (let i = 0; i < n; i++) if (!indeg[i]) q.push(i);
    while (out.length < n) {
      if (!q.length) { let best = -1; for (let i = 0; i < n; i++) if (!seen[i] && (best < 0 || depth[i] < depth[best])) best = i; q.push(best); }
      const i = q.shift(); if (seen[i]) continue; out.push(i); seen[i] = true;
      after[i].forEach(j => { if (--indeg[j] === 0 && !seen[j]) q.push(j); });
    }
    return out.map(i => boxes[i]);
  }

  function bounds(boxes) {
    let x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
    boxes.forEach(b => {
      const zt = b.z + b.h + (b.studs ? 0.5 : 0);
      [[b.x, b.y, b.z], [b.x + b.w, b.y, b.z], [b.x, b.y + b.d, b.z], [b.x + b.w, b.y + b.d, b.z],
      [b.x, b.y, zt], [b.x + b.w, b.y, zt], [b.x, b.y + b.d, zt], [b.x + b.w, b.y + b.d, zt]].forEach(([x, y, z]) => {
        const [sx, sy] = P(x, y, z); x0 = Math.min(x0, sx); x1 = Math.max(x1, sx); y0 = Math.min(y0, sy); y1 = Math.max(y1, sy);
      });
    });
    return { x0, y0, x1, y1 };
  }

  function drawBox(ctx, b, s, ox, oy) {
    const col = C[b.c] || b.c;
    const pt = (x, y, z) => { const [px, py] = P(x, y, z); return [ox + px * s, oy + py * s]; };
    const poly = (pts, fill) => { ctx.beginPath(); pts.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1])); ctx.closePath(); ctx.fillStyle = fill; ctx.fill(); ctx.strokeStyle = fill; ctx.lineWidth = 0.6; ctx.stroke(); };
    const { x, y, z, w, d, h } = b; const zt = z + h;
    poly([pt(x, y, zt), pt(x + w, y, zt), pt(x + w, y + d, zt), pt(x, y + d, zt)], shade(col, 0.18));
    poly([pt(x + w, y, z), pt(x + w, y + d, z), pt(x + w, y + d, zt), pt(x + w, y, zt)], shade(col, -0.3));
    poly([pt(x, y + d, z), pt(x + w, y + d, z), pt(x + w, y + d, zt), pt(x, y + d, zt)], shade(col, -0.1));
    if (b.studs && w >= 1 && d >= 1) {
      const r = 0.3, rx = r * 1.2247 * s, ry = r * 0.7071 * s, sh = 0.42 * PLATE * s;
      for (let i = 0; i < Math.floor(w + 1e-6); i++) for (let j = 0; j < Math.floor(d + 1e-6); j++) {
        const [cx, cy] = pt(x + i + 0.5, y + j + 0.5, zt);
        ctx.fillStyle = shade(col, -0.18); ctx.beginPath(); ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2); ctx.fill();
        ctx.fillRect(cx - rx, cy - sh, rx * 2, sh);
        ctx.fillStyle = shade(col, 0.3); ctx.beginPath(); ctx.ellipse(cx, cy - sh, rx, ry, 0, 0, Math.PI * 2); ctx.fill();
      }
    }
  }

  function render(canvas, opts) {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const cw = canvas.clientWidth || 600, ch = canvas.clientHeight || 450;
    if (cw < 2 || ch < 2) return;
    canvas.width = Math.round(cw * dpr); canvas.height = Math.round(ch * dpr);
    const ctx = canvas.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, cw, ch);
    const name = opts.model || 'car'; const fn = M[name] || M.car; const boxes = fn(opts.paint || {});
    const pad = opts.pad != null ? opts.pad : 0.12;
    const bb = bounds(boxes); const bw = bb.x1 - bb.x0, bh = bb.y1 - bb.y0;
    const scale = Math.min(cw * (1 - 2 * pad) / bw, ch * (1 - 2 * pad) / bh) * (opts.zoom || 1);
    const ax = opts.align || 'center';
    const cx = ax === 'right' ? cw - cw * pad - bw * scale / 2 + (opts.shift || 0) * cw : ax === 'left' ? cw * pad + bw * scale / 2 + (opts.shift || 0) * cw : cw / 2 + (opts.shift || 0) * cw;
    const vy = opts.valign === 'bottom' ? ch - ch * pad - bh * scale / 2 : opts.valign === 'top' ? ch * pad + bh * scale / 2 : ch / 2;
    const ox = cx - (bb.x0 + bw / 2) * scale, oy = vy - (bb.y0 + bh / 2) * scale + (opts.dy || 0) * ch;
    if (opts.shadow !== 'none') {
      let gx0 = 1e9, gx1 = -1e9, gy0 = 1e9, gy1 = -1e9;
      boxes.filter(b => b.z <= 0.5).forEach(b => { [[b.x, b.y], [b.x + b.w, b.y], [b.x, b.y + b.d], [b.x + b.w, b.y + b.d]].forEach(([x, y]) => { const [sx, sy] = P(x, y, 0); gx0 = Math.min(gx0, sx); gx1 = Math.max(gx1, sx); gy0 = Math.min(gy0, sy); gy1 = Math.max(gy1, sy); }); });
      if (gx0 < 1e8) {
        const scx = ox + (gx0 + gx1) / 2 * scale, scy = oy + (gy0 + gy1) / 2 * scale + 0.1 * scale;
        const rx = (gx1 - gx0) / 2 * scale * 1.25 + 0.4 * scale, ry = (gy1 - gy0) / 2 * scale * 1.15 + 0.3 * scale;
        const g = ctx.createRadialGradient(scx, scy, 0, scx, scy, rx);
        const light = opts.shadow === 'light';
        g.addColorStop(0, light ? 'rgba(255,255,255,0.16)' : 'rgba(0,0,0,0.2)'); g.addColorStop(0.7, light ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.05)'); g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.save(); ctx.translate(scx, scy); ctx.scale(1, ry / rx); ctx.translate(-scx, -scy); ctx.fillStyle = g; ctx.beginPath(); ctx.arc(scx, scy, rx, 0, Math.PI * 2); ctx.fill(); ctx.restore();
      }
    }
    order(boxes).forEach(b => drawBox(ctx, b, scale, ox, oy));
  }

  function renderAll(root) {
    (root || document).querySelectorAll('canvas[data-model]').forEach(cv => {
      let paint = {}; try { paint = cv.dataset.paint ? JSON.parse(cv.dataset.paint) : {}; } catch (e) { }
      const d = cv.dataset, m = (cv.clientWidth || 600) < 640;
      const g = (k) => (m && d['m' + k.charAt(0).toUpperCase() + k.slice(1)] != null) ? d['m' + k.charAt(0).toUpperCase() + k.slice(1)] : d[k];
      render(cv, { model: d.model, paint, shadow: g('shadow'), pad: g('pad') != null ? +g('pad') : undefined, zoom: g('zoom') ? +g('zoom') : 1, align: g('align'), valign: g('valign'), shift: g('shift') ? +g('shift') : 0, dy: g('dy') ? +g('dy') : 0 });
    });
  }
  window.Iso = { render, renderAll, models: M, colors: C };
})();
